export default __webpack_public_path__ + "imgs/toForever.1cfebea.jpeg";